export const downloadBlob = (blob, filename = "download") => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export const filenameFromContentDisposition = (
  header,
  fallback = "download",
) => {
  const matched = header?.match(/filename="?([^"]+)"?/i);
  return matched?.[1] || fallback;
};

export const downloadFromUrl = async (
  fileUrl,
  fallbackFilename = "download",
) => {
  const response = await fetch(fileUrl);
  if (!response.ok) {
    const error = new Error("Failed to download file");
    error.status = response.status;
    throw error;
  }

  const blob = await response.blob();
  const filename = filenameFromContentDisposition(
    response.headers.get("Content-Disposition"),
    fallbackFilename,
  );
  downloadBlob(blob, filename);
};
